import React, { useState } from 'react';
import './SearchForm.css';

export default function TeacherSearchForm({ onSearch }) {
  const [subject, setSubject] = useState('');
  const [city, setCity] = useState('');
  const [genre, setGenre] = useState(''); // nouvel état

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch({ subject, city, genre }); // inclure genre dans les filtres
  };

  return (
    <form className="search-form" onSubmit={handleSubmit}>
      <select value={subject} onChange={(e) => setSubject(e.target.value)}>
        <option value="">Toutes les matières</option>
        <option value="Chant">Chant</option>
        <option value="Guitare">Guitare</option>
        <option value="Batterie">Batterie</option>
        <option value="Piano">Piano</option>
        <option value="Danse">Danse</option>
        <option value="Violoncelle">Violoncelle</option>
      </select>

      <select value={genre} onChange={(e) => setGenre(e.target.value)}>
        <option value="">Tous les genres</option>
        <option value="Jazz">Jazz</option>
        <option value="Classique">Classique</option>
        <option value="Pop">Pop</option>
        <option value="Rock">Rock</option>
        <option value="Blues">Blues</option>
      </select>

      <select value={city} onChange={(e) => setCity(e.target.value)}>
        <option value="">Toutes les villes</option>
        <option value="Marrakech">Marrakech</option>
        <option value="Rabat">Rabat</option>
        <option value="Casablanca">Casablanca</option>
        <option value="Tanger">Tanger</option>
        <option value="Benguerir">Benguerir</option>
      </select>

      <button type="submit">Rechercher</button>
    </form>
  );
}
